import React from "react";

export default function Ribbon() {
  return (
    <section className="ribbon">

      <div className="container">
        <div className="content">
          <div className="content">
            <div className="text-center" style={{lineHeight: '36px'}}><i className="fa-duotone fa-phone"></i> <a
              className="link-light" href="tel://1300 552 619">1300 552 619</a></div>
          </div>
        </div>
      </div>


    </section>
  );
}





